<script setup lang="ts">
import FormPatrocinio from '../components/form-patrocinio.vue'
import { usePatrocinioStore } from '../store/usePatrocinioStore'

definePage({
  meta: {
    navActiveLink: 'admin-patrocinio',
    action: 'create',
    subject: 'patrocinio',
  },
})

const { resetForm } = usePatrocinioStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormPatrocinio />
</template>
